module.exports = __webpack_public_path__ + "img/21.f87f6eb8.jpg";